import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import {
    defaultState,
    EventCentreDialogState,
} from '../event-centre-dialog.state';

import { Reload } from './reload.action';

export function resetReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType.NOTI__EC__RESET, Reload>,
): EventCentreDialogState {
    return defaultState();
}
